// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loadingSpinnerWrapper--2bR65 {\n  height: 300px;\n}\n", ""]);
// Exports
exports.locals = {
	"loadingSpinnerWrapper": "loadingSpinnerWrapper--2bR65"
};
module.exports = exports;
